const DialogBody: FC = ({ children }) => (
  <div className="grid gap-6 p-6 pt-4" data-testid="2FA-dialog">
    {children}
  </div>
);

export default DialogBody;
